<template>
  <div class="contetn">
    <div class="w-1200 body-inner">
      <div class="order-item" @click="handleClick" v-for="(item, index) in formList" :key="index">
        <div class="order-title">
          <div class="order-one">采购单{{ index + 1 }}</div>
          <div class="delete-add">
            <div class="hit-cursor" @click="deleteOrder(index)">删除</div>
            <div class="add hit-cursor" @click="addOrder">添加</div>
          </div>
        </div>

<!--     :disabled="userInfo.is_check !=1"   -->

        <div class="order-content" v-loading="loading">
          <el-form ref="form" :model="item" label-width="110px" label-position="right" :rules="rules">
            <el-row>
              <el-col :span="8">
                <el-form-item label="CAS编号" prop="cas_no">
                  <!--                  <el-input v-model="item.cas_no" placeholder="请输入CAS号" @blur="querySearch"/>-->
                  <el-autocomplete ref="casAutocomplete" class="inline-input" v-model="item.cas_no"
                                   :fetch-suggestions="getInner"
                                   placeholder="请输入CAS号、中文名称、英文名称" :trigger-on-focus="false" :debounce="300"
                                   @input="onInput" clearable
                                   :style="{ width: '100%' }"
                                   :value-key="'value'" :select-when-unmatched="false"
                                   >
                    <template slot-scope="{ item }">
                      <div class="suggestion-item">
                        <div class="suggestion-content">
                          <span class="cas-no">{{ item.cas_no || '--' }}</span>
                          <span class="separator">|</span>
                          <span class="name">{{ item.name || '--' }}</span>
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="需求量" prop="number">
                  <el-input type="number" step="0.001" v-model="item.number" placeholder="请输入需求量"
                            style="width:325px;" @input="handleNumberInput($event, item)">
                    <el-select style="width: 100px;" prop="unit" v-model="item.unit" slot="append" class="unit-select"
                               placeholder="请选择单位">
                      <el-option v-for="i in unitList" :key="i.id" :label="i.label" :value="i.label"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否接受定制" prop="is_quotes">
                  <el-radio-group v-model="item.is_quotes" >
                    <el-radio :label="1"> 是</el-radio>
                    <el-radio :label="0"> 否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" class="invoice-type">
                <el-form-item label="发票类型" prop="invoice_type">
                  <el-select v-model="item.invoice_type"  placeholder="请选择发票类型">
                    <el-option label="增值税专用发票（13%）" value="1"></el-option>
                    <el-option label="增值税普通发票" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="询单有效期" prop="valid_day">
                  <el-select v-model="item.valid_day" placeholder="请选择" 
                             :style="{ width: '100%' }">
                    <el-option
                        label="3天"
                        :value="3">
                    </el-option>
                    <el-option
                        label="1周"
                        :value="7">
                    </el-option>
                    <el-option
                        label="1个月"
                        :value="30">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="寄往地区" prop="district">
                  <el-cascader v-model="item.district" :options="areaOptions" :props="{ expandTrigger: 'hover' }"
                               :style="{ width: '100%' }" ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" v-if="false">
                <el-form-item label="期望价格" prop="expected_price">
                  <el-input v-model="item.expected_price" 
                            placeholder="请输入期望价格"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="备注">
                  <el-input v-model="item.remark"  placeholder="请输入备注"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="input-box"></div>
        </div>
      </div>
      <div class="submit-box">
        <div class="button-box">
          <el-button class="submit-btn" @click="handleCancel">取消</el-button>
          <el-button class="submit-btn save" @click="handleConfirm">确认</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {purchaseAdd, checkCasNo, purchaseDetail} from "@/api/modules/user";
import {getAreaOptions, getCasOptions} from "@/api/modules/common";
import {mapGetters} from "vuex";

export default {
  name: "release",
  data() {
    return {
      confirmTimer: true, // 添加防抖定时器
      isLoading: false,
      loading: false,
      selectedCasItem: [], // 保存选中的CAS项
      id: '',
      formList: [
        {
          cas_no: "",
          number: "",
          is_quotes: 0,
          invoice_type: "",
          valid_day: "",
          district: [],
          expected_price: "",
          remark: "",
          unit: "kg",
        },
      ],
      needType: "",
      areaOptions: [],
      rules: {
        cas_no: [{required: true, message: "请输入CAS号", trigger: "blur"}],
        number: [{required: true, message: "请输入需求量", trigger: "blur"}],
        unit: [{required: true, message: "请选择单位", trigger: "change"}],
        invoice_type: [
          {required: true, message: "请选择发票类型", trigger: "blur"},
        ],
        district: [
          {required: true, message: "请选择收货地区", trigger: "blur"},
        ],
        expected_price: [{
          validator: (rule, value, callback) => {
            if (!value) {
              // 如果为空，则通过验证（非必填）
              callback();
            } else {
              const price = Number(value);
              if (isNaN(price)) {
                callback(new Error('请输入有效的数字'));
              } else if (price <= 0) {
                callback(new Error('期望价格必须大于0'));
              } else {
                callback();
              }
            }
          },
          trigger: 'blur'
        }],
        valid_day: [
          {required: true, message: "请选择询单有效期", trigger: "change"},
        ],
        is_quotes: [
          {required: true, message: "请选择是否接受定制", trigger: "blur"},
        ],
      },
    };
  },
  watch: {
    // 监听整条路由对象，兼容 query 和 params，并在初始加载时立即执行
    '$route': {
      handler: function (route) {
        const id = (route && (route.query && route.query.id)) || (route && (route.params && route.params.id));
        if (id) {
          this.id = id;
          this.getDetail();
        } else {
          this.loading = false;
          this.formList = [
            {
              cas_no: "",
              number: "",
              is_quotes: 1,
              invoice_type: "",
              valid_day: "",
              district: [],
              expected_price: "",
              remark: "",
              unit: "kg",
            },
          ]
        }
      },
      immediate: true,
      deep: false
    }
  },
  created() {
    this.init();
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    unitList() {
      return this.$store.state.config.unitList
    },
  },
  methods: {
    // 需求量输入限制：只允许数字和小数点，小数点后最多3位（formList 数组项）
    handleNumberInput(value, item) {
      let val = String(value == null ? '' : value);
      // 移除非数字和小数点字符
      val = val.replace(/[^\d.]/g, '');
      // 多个小数点只保留第一个
      const firstDot = val.indexOf('.');
      if (firstDot !== -1) {
        const intPart = val.slice(0, firstDot + 1);
        const decPart = val.slice(firstDot + 1).replace(/\./g, '');
        val = intPart + decPart;
        // 限制小数点后最多3位
        const dotIndex = val.indexOf('.');
        if (dotIndex !== -1 && val.length - dotIndex - 1 > 3) {
          val = val.slice(0, dotIndex + 4);
        }
      }
      if (val !== String(item.number == null ? '' : item.number)) {
        item.number = val;
      }
    },
    // 点击
    handleClick(index) {
      // if (this.userInfo.is_check !== 1) {
      //   this.$message.error('审核未通过！不能发布询单！');
      //   return;
      // }
    },
    // 输入防抖处理
    onInput() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        // 可以在这里添加输入验证逻辑
      }, 300);
    },
    // 获取搜索建议
    async getInner(queryString, cb) {
      if (!queryString || queryString.trim().length < 1) {
        cb([]);
        return;
      }

      try {
        this.isLoading = true;
        const res = await getCasOptions({keyword: queryString.trim()});

        if (res.data && res.data.code === 10000 && res.data.data) {
          // 确保返回的数据格式正确
          let suggestions = [];
          if (Array.isArray(res.data.data)) {
            suggestions = res.data.data;
          } else if (res.data.data.data && Array.isArray(res.data.data.data)) {
            suggestions = res.data.data.data;
          } else if (res.data.data.map && Array.isArray(res.data.data.map)) {
            suggestions = res.data.data.map;
          }

          // 格式化建议数据
          const formattedSuggestions = suggestions.map(item => {
            const displayValue = item.cas_no || item.name || item.name_en || '';
            return {
              ...item,
              value: displayValue,
              label: displayValue
            };
          });

          cb(formattedSuggestions);
        } else {
          cb([]);
        }
      } catch (error) {
        this.$message.error('获取搜索建议失败，请稍后重试');
        cb([]);
      } finally {
        this.isLoading = false;
      }
    },

    getDetail() {
      this.loading = true;
      purchaseDetail(this.id).then((res) => {
        if (res.data.code == 10000) {
          let item = res.data.data;
          if (item) {
            let info = {
              cas_no: item.cas_no,
              number: item.number,
              is_quotes: item.is_quotes == 1 ? 1 : 2,
              invoice_type: item.invoice_type.toString(),
              valid_day: item.valid_day,
              district: [item.provinceId, item.cityId, item.areaId],
              expected_price: item.expected_price,
              remark: item.remark,
              unit: item.unit,
            };
            this.formList = [info];
            this.loading = false;
          }

        }
      });
    },
    async querySearch(e) {
      if (e.target.value.trim()) {
        let res = await checkCasNo(e.target.value);
        if (res.data.code != 10000) {
          this.$message.error({
            message: "cas号不存在请重新输入",
            duration: 2000,
            offset: 200,
          });
          setTimeout(() => {
            this.formList[0].cas_no = "";
          }, 1000);
        }
      }
    },
    init() {
      // 获取区域选项
      getAreaOptions().then((res) => {
        this.areaOptions = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
            children: item.children.map((item) => {
              return {
                value: item.id,
                label: item.name,
                children: item.children.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                }),
              };
            }),
          };
        });
      });
    },
    handleCancel() {
      this.$router.back();
    },
    // 用户点击确认按钮
    handleConfirm() {
      // 清除之前的定时器
      if (this.confirmTimer) {
        this.confirmTimer = false
      } else {
        return;
      }
      // 设置新的定时器，300ms 防抖
      //2026-01-10 修改注册流程
      // if (this.userInfo.is_check !== 1) {
      //   this.$message.error('未填写基本信息或审核未通过！不能发布询单！');
      //   return;
      // }
      let formData = JSON.parse(JSON.stringify(this.formList));
      for (let i = 0; i < formData.length; i++) {
        let data = formData[i];
        if (data.cas_no == "") {
          this.$message.error({
            message: "请输入采购单" + (i + 1) + "的CAS编号",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        }
        if (data.number == "") {
          this.$message.error({
            message: "请输入采购单" + (i + 1) + "的需求量",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        }
        if (data.unit == "") {
          this.$message.error({
            message: "请选择采购单" + (i + 1) + "的产品单位",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        }
        if (data.is_quotes.length == 0) {
          this.$message.error({
            message: "请选择采购单" + (i + 1) + "是否接受定制！",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        }
        // else {
        //   data.is_quotes = Number(data.is_quotes[0]);
        // }
        if (data.invoice_type == "") {
          this.$message.error({
            message: "请选择采购单" + (i + 1) + "的发票类型",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        } else {
          data.invoice_type = Number(data.invoice_type);
        }
        if (data.valid_day == "") {
          this.$message.error({
            message: "请输入采购单" + (i + 1) + "的询单有效期",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        } else {
          if (data.valid_day <= 0) {
            this.$message.error({
              message: "采购单" + (i + 1) + "的询单有效期不能小于等于0",
              duration: 2000,
              offset: 200,
            });
            this.confirmTimer = true
            return;
          }
        }
        if (data.district.length == 0) {
          this.$message.error({
            message: "请选择采购单" + (i + 1) + "的寄往地区",
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          return;
        }
        if (data.expected_price) {
          // 判断价格是否为数字
          if (!/^\d+(\.\d+)?$/.test(data.expected_price)) {
            this.$message.error({
              message: "请输入采购单" + (i + 1) + "正确的期望价格",
              duration: 2000,
              offset: 200,
            });
            this.confirmTimer = true
            return;
          }
          // 判断价格是否大于0
          if (data.expected_price <= 0) {
            this.$message.error({
              message: "请输入采购单" + (i + 1) + "正确的期望价格",
              duration: 2000,
              offset: 200,
            });
            this.confirmTimer = true
            return;
          }
        }
      }
      purchaseAdd({info: formData}).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.confirmTimer = true
          this.$router.back();
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });
    },
    deleteOrder(index) {
      this.formList.splice(index, 1);
    }
    ,
    addOrder() {
      this.formList.push({
        cas_no: "",
        number: "",
        is_quotes: [],
        invoice_type: "",
        valid_day: "",
        district: [],
        expected_price: "",
        remark: "",
        unit: "",
      });
    }
    ,
    changeNeed(val, index) {
      this.formList[index].needType = val;
    }
    ,
  },
};
</script>
<style scoped lang="scss">
.contetn {
  padding-bottom: 100px;
}

.invoice-type {
  ::v-deep .el-select {
    width: 100%;
  }
}

// 全局样式，确保所有el-select宽度为100%
// ::v-deep .el-select {
//   width: 100%;
//   .el-input {
//     width: 100%;
//   }
// }
::v-deep .el-date-editor.el-input {
  width: 100%;
}

.unit-select {
  width: 70px;
}

.body-inner {
  box-sizing: border-box;
  // height: 903px;
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  padding: 40px;

  .submit-box {
    text-align: center;
    padding-top: 41px;

    .save {
      background: #0c60e6;
      border: 1px solid #0c60e6 !important;
      color: #ffffff;
      margin-right: 20px;
    }

    .submit-btn {
      display: inline-block;
      width: 120px;
      height: 50px;
      font-size: 18px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5f616c;
      font-weight: 400;
    }
  }

  .order-item {
    height: 323px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #afafaf;
    padding: 0 40px;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .order-title {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      height: 73px;
      border-bottom: 1px solid #afafaf;
      padding-top: 25px;

      .order-one {
        font-weight: bold;
        font-size: 20px;
        color: #00112b;
      }

      .delete-add {
        display: flex;
        font-weight: 500;
        font-size: 18px;
        color: #00112b;

        .add {
          margin-left: 82px;
        }
      }
    }

    .order-content {
      padding-top: 32px;
    }
  }
}
</style>
